import React, { useEffect, useState } from 'react';
import { Routes, Route, HashRouter } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { useOfflineSyncDaemon } from 'hooks/useOfflineSyncDaemon';
import resolveRoutes from 'assets/routes/resolveRoutes';
import { useTenantData } from 'providers/Tenant/TenantDataProvider';
import { TrazabilidadDrawerProvider } from 'providers/Trazabilidad/TrazabilidadDrawerProvider';

const SecureRouter = () => {
  useOfflineSyncDaemon();
  const { user, isLoading, perfilActivo: hatFromCtx } = useAuth();
  const perfilActivo = hatFromCtx ?? user?.type;
  const { tenant } = useTenantData();
  const plan = tenant?.plan ?? 'lite';
  const [routes, setRoutes] = useState(null);

  useEffect(() => {
    if (!isLoading) setRoutes(resolveRoutes(perfilActivo, plan));
  }, [isLoading, perfilActivo, plan]);

  return (
    <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      {/* TrazabilidadDrawerProvider vive DENTRO del HashRouter: los drawers que
          renderiza (HallazgoDetailDrawer, etc.) usan useNavigate y necesitan el
          contexto del Router. Todos sus consumidores son páginas dentro de Routes. */}
      <TrazabilidadDrawerProvider>
        {routes ? (
          <Routes>
            {routes.map((route, index) => (
              <Route
                key={String(index)}
                path={route.path}
                element={
                  <route.layout>
                    <route.element />
                  </route.layout>
                }
              />
            ))}
          </Routes>
        ) : null}
      </TrazabilidadDrawerProvider>
    </HashRouter>
  );
};

export default SecureRouter;
